import * as React from 'react';
import { Constants } from '../utils/constants';
import { getTrimmedWords } from './../utils/stringUtils';
var css = /*#__PURE__*/ function(css) {
    css["searchInputClassName"] = "resizable-input";
    css["searchButtonClassName"] = ".spza-c-search .react-selectize-control .react-selectize-toggle-button-container .c-glyph";
    css["searchInputIdName"] = "marketplace-selectize-search-input";
    css["searchDivInputClassName"] = " .spza-header-search-section";
    css["searchFocusInputClassName"] = " .spza-header-row-segment-middle";
    css["headerPrefixClassName"] = ".spza-header-";
    return css;
}(css || {});
export function getSearchElement(prefix, key) {
    const elements = document.querySelectorAll(prefix + key);
    const searchInput = document.querySelector(prefix + " .spza-header-search-section");
    let searchElement = null;
    if (elements) {
        for(let i = 0; i < elements.length; i++){
            if (elements[`${i}`].contains(searchInput)) {
                searchElement = elements[`${i}`];
                break;
            }
        }
        return searchElement;
    }
}
export function onKeyBlurOptionHandle(event, componentKey) {
    const searchInput = getSearchElement(`${".spza-header-"}${componentKey.substring(0, componentKey.indexOf('-'))}`, " .spza-header-row-segment-middle");
    if (searchInput) {
        searchInput.classList.remove('spza-header-row-segment-middle-focus');
    }
}
export function onKeyFocusOptionHandle(event, componentKey) {
    if (event.keyCode === Constants.SystemKey.Tab) {
        const searchInput = getSearchElement(`${".spza-header-"}${componentKey.substring(0, componentKey.indexOf('-'))}`, " .spza-header-row-segment-middle");
        if (searchInput) {
            searchInput.classList.add('spza-header-row-segment-middle-focus');
        }
    }
}
/**
 * This method is to escape any special characters required on https://aka.ms/azure-search-full-query
 * In that way, the escaped search text could then be used as search queries when calling azure search api
 *
 * @param rawSearchText raw search text from user input
 * @param excludeQuotes true if double quotes are to be excluded from the escape sequence.
 */ export function getEscapedSearchText(rawSearchText, excludeQuotes = false) {
    // characters required to escape, reference: https://aka.ms/azure-search-full-query
    const charactersToEscape = '+ - && || ! ( ) { } [ ] ^ ~ ? : / \\ * AND OR NOT' + (excludeQuotes ? '' : ' "');
    // make an array of characters to escape, each element is a string, which consists of characters,
    // e.g. an array of characters to escape ['+', '&&'], '+' and '&&' are strings
    // and escape every character in each string
    // e.g. ['+', '&&'] => ['\+', '\&\&']
    // the purpose of this array is to use in regex pattern
    const escapedCharactersList = getTrimmedWords(charactersToEscape)// get each string, e.g. +, &&
    .map((stringToEscape)=>stringToEscape// get each character in current string
        .split('')// escape each character, e.g. \+, \&
        .map((character)=>`\\${character}`)// rejoin each escaped character to form as an escaped string, e.g. \+, \&\&
        .join(''));
    // escape pattern is a regex pattern, by OR-ing each escaped string of escaped array,
    // which means that'd be a match, if an input string include any of escaped string in the escaped array
    const escapePattern = `${escapedCharactersList// wrap parenthesis around each element as a regex group
    .map((escapedString)=>`(${escapedString})`)// make regex to match any of them
    .join('|')}`;
    // use global to match all occurrences of escape pattern
    // eslint-disable-next-line security/detect-non-literal-regexp
    const escapeRegex = new RegExp(escapePattern, Constants.RegExpFlag.Global);
    // escape input string whenever there's a match with escape pattern
    const escapedSearchText = rawSearchText.replace(escapeRegex, (matchedString)=>// escape each character in each matched substring
        `${matchedString.split('').map((character)=>`\\${character}`).join('')}`);
    return escapedSearchText;
}
/**
 * Perform a search with the following guidelines:
 * 1) Escape special characters.
 * 2) Add a '+' character as a prefix for a search that starts and ends with a '"'.
 * 3) Add 'And' between the search words.
 * @param rawSearchText Raw search text from user input.
 */ export function getSearchQuery(rawSearchText = '') {
    rawSearchText = typeof rawSearchText === 'string' ? rawSearchText : '';
    if (rawSearchText.length > Constants.Search.maxSearchTextLength) {
        const isCutInTheMiddleOfWord = rawSearchText[Constants.Search.maxSearchTextLength - 1] !== ' ' && rawSearchText[Constants.Search.maxSearchTextLength] !== ' ';
        rawSearchText = rawSearchText.slice(0, Constants.Search.maxSearchTextLength);
        const splittedBySpaces = rawSearchText.split(/\s+/);
        if (splittedBySpaces.length > 1 && isCutInTheMiddleOfWord) {
            splittedBySpaces.pop();
        }
        rawSearchText = splittedBySpaces.join(' ');
    }
    // catches all phrases surrounded by double quotes.
    const re = /"(.*?)"/g;
    const phrases = rawSearchText.match(re);
    const searchPhrases = phrases ? phrases.map((p)=>`+${getEscapedSearchText(p)}`) : [];
    const words = rawSearchText.replace(re, '').split(' ').map((w)=>w.trim()).filter((w)=>!!w).map((w)=>`${getEscapedSearchText(w)}`);
    const searchTerm = [
        ...searchPhrases,
        ...words
    ].join(' ');
    return searchTerm;
}
export function parseSearchAction(request) {
    var _request_headers;
    return ((_request_headers = request.headers) === null || _request_headers === void 0 ? void 0 : _request_headers.searchactiontype) === Constants.Search.ActionType.Suggestions ? Constants.Search.ActionType.Suggestions : Constants.Search.ActionType.Search;
}
export function removeDuplicateAddIns(apps, idField) {
    const linkedAddIns = Constants.SearchFieldNames.linkedAddIns;
    let bundleCount = 0;
    const linkedAddInIds = {};
    for (const currentApp of apps){
        if (currentApp && currentApp[`${linkedAddIns}`] && currentApp[`${linkedAddIns}`].length > 0) {
            bundleCount++;
            for (const currentAddIns of currentApp[`${linkedAddIns}`]){
                if (currentAddIns && currentAddIns[`${idField}`]) {
                    linkedAddInIds[currentAddIns[`${idField}`]] = true;
                }
            }
        }
    }
    const uniqueApps = apps.filter((currentApp)=>{
        const currentAppId = currentApp && currentApp[`${idField}`] && currentApp[`${idField}`].toString() || '';
        return !(currentAppId && linkedAddInIds[`${currentAppId}`]);
    });
    const duplicateAddInsCount = apps.length - uniqueApps.length;
    return {
        apps,
        bundleCount,
        duplicateAddInsCount
    };
}
